module.exports = __webpack_public_path__ + "static/img/hueso-roto.c826be0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/iconos/svg/hueso-roto.svg
// module id = f2uw
// module chunks = 1